module.exports = __webpack_public_path__ + "static/media/java.49c605f0.svg";